import { z } from 'zod';

// What the Request Access form offers. A CLIENT MIRROR of the server's
// REQUESTABLE_JOB_ROLES (server/src/constants/index.ts), which is the authority -
// the register validator rejects anything outside it.
//
// Narrower than JOB_ROLES on purpose: 'Renewal' is gone because Renewals is
// worked by the Billing desk (one team, one option), and 'Super Admin' is gone
// because there is one admin level. Both remain valid stored values for accounts
// that predate this list.
export const ROLE_OPTIONS = ['Sales RM', 'Billing', 'Service', 'Admin'] as const;

// Registration collects the full profile. The mobile is then OTP-verified and
// the account is created PENDING admin approval. Login is OTP-only, so no
// password is collected here.
export const registerSchema = z.object({
  name: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be under 100 characters'),
  mobile: z.string().regex(/^\d{10}$/, 'Enter a valid 10-digit mobile number'),
  email: z.string().min(1, 'Work email is required').email('Enter a valid email address'),
  role: z.string().min(1, 'Please select a role'),
});

export type RegisterFormValues = z.infer<typeof registerSchema>;
